export default "__VITE_ASSET__D89XUcL9__"